module.exports = __webpack_public_path__ + "img/case-list-text.9aa2d898.png";